import React from 'react';
import LazyLoad from 'react-lazyload';
import { useResponsive } from 'src/components/Responsive/Responsive';

interface Props {
  offset?: number;
  children: React.ReactNode;
}

export const LazyLoader = ({ offset, children }: Props) => {
  const { browser } = useResponsive();
  const isMobile = browser.is.mobile;
  const windowInnerHeight = window.innerHeight;
  const defaultImageOffset = isMobile ? windowInnerHeight : (windowInnerHeight * 2);
  const imageOffset = offset ? offset : defaultImageOffset;

  return (
    <LazyLoad offset={imageOffset} height="100%">
      {children}
    </LazyLoad>
  );
};
